import canvasPlugin from './canvas'

const useAllTestPlugins = () => {
  canvasPlugin()
}

export { canvasPlugin, useAllTestPlugins }
